
export const DOWNVOTE = 0;
export const UPVOTE = 1;
export const NO_VOTE = 2;

/** changeVote applies vote action `dir` to vote value `vote`,
 *  and returns the updated vote value.
 * @param vote 0 downvote, 1 upvote, 2 no vote
 * @param dir 0 downvote, 1 upvote
 * @returns {number|*}
 */
export const changeVote = (vote, dir) => {
    return vote === dir ? NO_VOTE : dir;
};

export const voteValue = (vote = NO_VOTE) => [-1, 1, 0][vote];
